module.exports = __webpack_public_path__ + "img/1493348424.8ea14b26.jpg";